/* MyFitCheese — full calorie calculator page (Mifflin-St Jeor). Ported from Lovable. */
(function () {
  var root = document.querySelector("[data-mfc-calc-full]");
  if (!root) return;

  var ACTIVITY = { sedentaire: 1.2, leger: 1.375, modere: 1.55, actif: 1.725, tres_actif: 1.9 };
  var GOALS = {
    perte: { delta: -0.2, tone: "Déficit ~20%" },
    maintien: { delta: 0, tone: "Calories d'entretien" },
    prise: { delta: 0.1, tone: "Surplus ~10%" }
  };
  var PACKS = [
    { name: "Pack 6", sub: "6 × 60g", price: "35,94€", perUnit: "5,99€/sachet" },
    { name: "Pack 12", sub: "12 × 60g", price: "47,88€", perUnit: "3,99€/sachet" },
    { name: "Pack 24", sub: "24 × 60g", price: "84,00€", perUnit: "3,50€/sachet" },
    { name: "Pack 36", sub: "36 × 60g", price: "107,64€", perUnit: "2,99€/sachet" }
  ];
  function pickPack(monthlyG) {
    if (monthlyG <= 450) return PACKS[0];
    if (monthlyG <= 900) return PACKS[1];
    if (monthlyG <= 1700) return PACKS[2];
    return PACKS[3];
  }

  var state = { sex: "h", age: 28, weight: 75, height: 178, activity: "modere", goal: "perte" };
  var fr = function (n) { return Math.round(n).toLocaleString("fr-FR"); };
  var q = function (s) { return root.querySelector(s); };
  var qa = function (s) { return root.querySelectorAll(s); };
  var setText = function (sel, v) { var el = q(sel); if (el) el.textContent = v; };

  function render() {
    var s = state;
    var bmr = s.sex === "h"
      ? 10 * s.weight + 6.25 * s.height - 5 * s.age + 5
      : 10 * s.weight + 6.25 * s.height - 5 * s.age - 161;
    var tdee = bmr * ACTIVITY[s.activity];
    var target = tdee * (1 + GOALS[s.goal].delta);
    var protG = Math.round(2 * s.weight);
    var fatG = Math.round(1 * s.weight);
    var remaining = Math.max(0, target - protG * 4 - fatG * 9);
    var carbG = Math.round(remaining / 4);

    setText('[data-out="tone"]', "Ton objectif quotidien · " + GOALS[s.goal].tone);
    setText('[data-out="target"]', fr(target) + " kcal");
    setText('[data-out="bmr"]', fr(bmr) + " kcal");
    setText('[data-out="tdee"]', fr(tdee) + " kcal");
    setText('[data-out="prot"]', protG + "g");
    setText('[data-out="fat"]', fatG + "g");
    setText('[data-out="carb"]', carbG + "g");
    setText('[data-out="tip-pct"]', Math.round((15 / protG) * 100) + "%");

    // Pack suggestion
    var freq = protG < 100 ? 3 : protG < 140 ? 4 : protG < 180 ? 5 : 6;
    var portion = 20;
    var monthlyG = Math.round(portion * freq * 4.3);
    var pack = pickPack(monthlyG);
    setText('[data-out="pack-name"]', pack.name + " - " + pack.sub);
    setText('[data-out="pack-basis"]', "Sur la base de " + portion + "g par repas, " + freq + " repas/sem (~" + fr(monthlyG) + "g par mois).");
    setText('[data-out="pack-price"]', pack.price);
    setText('[data-out="pack-perunit"]', pack.perUnit);

    // active states
    qa("[data-sex]").forEach(function (b) { b.classList.toggle("is-active", b.getAttribute("data-sex") === s.sex); });
    qa("[data-activity]").forEach(function (b) { b.classList.toggle("is-active", b.getAttribute("data-activity") === s.activity); });
    qa("[data-goal]").forEach(function (b) { b.classList.toggle("is-active", b.getAttribute("data-goal") === s.goal); });
  }

  qa("[data-sex]").forEach(function (b) { b.addEventListener("click", function () { state.sex = b.getAttribute("data-sex"); render(); }); });
  qa("[data-activity]").forEach(function (b) { b.addEventListener("click", function () { state.activity = b.getAttribute("data-activity"); render(); }); });
  qa("[data-goal]").forEach(function (b) { b.addEventListener("click", function () { state.goal = b.getAttribute("data-goal"); render(); }); });
  qa("[data-field]").forEach(function (inp) {
    inp.addEventListener("input", function () {
      var min = +inp.min, max = +inp.max, v = Number(inp.value);
      if (!isNaN(v)) { state[inp.getAttribute("data-field")] = Math.max(min, Math.min(max, v)); render(); }
    });
  });

  /* ---- BoosterPack modal (click-triggered only, no auto-open) ---- */
  var modal = q("[data-booster]");
  function show(stepSel) {
    ["[data-step='1']", "[data-step='2']", "[data-step='success']"].forEach(function (sel) {
      var el = q(sel); if (el) el.style.display = (sel === stepSel) ? "" : "none";
    });
  }
  function openModal() { if (modal) { modal.style.display = "flex"; show("[data-step='1']"); } }
  function closeModal() { if (modal) modal.style.display = "none"; }
  qa("[data-booster-open]").forEach(function (b) { b.addEventListener("click", openModal); });
  qa("[data-booster-close]").forEach(function (b) { b.addEventListener("click", closeModal); });
  if (modal) modal.addEventListener("click", function (e) { if (e.target === modal) closeModal(); });
  /* ---- Klaviyo : capture email (etape 1) puis SMS (etape 2) dans la liste privee ---- */
  var KLAVIYO_COMPANY = "VnSEbs";
  var KLAVIYO_LIST = "RLquMW";
  var boosterEmail = "";
  function klaviyoSubscribe(profileAttrs) {
    try {
      return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_COMPANY, {
        method: "POST",
        headers: { "Content-Type": "application/json", revision: "2025-07-15" },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              custom_source: "Calculateur - Kit MyFitCheese",
              profile: { data: { type: "profile", attributes: profileAttrs } }
            },
            relationships: { list: { data: { type: "list", id: KLAVIYO_LIST } } }
          }
        })
      }).catch(function () {});
    } catch (e) { return; }
  }
  function toE164FR(raw) {
    var p = (raw || "").replace(/[\s().\-]/g, "");
    if (/^\+\d{8,15}$/.test(p)) return p;
    if (/^0\d{9}$/.test(p)) return "+33" + p.slice(1);
    if (/^33\d{9}$/.test(p)) return "+" + p;
    return null;
  }
  var emailForm = q("[data-email-form]");
  if (emailForm) emailForm.addEventListener("submit", function (e) {
    e.preventDefault();
    var inp = emailForm.querySelector("input[type=email]");
    var email = inp ? (inp.value || "").trim() : "";
    if (!email) return;
    boosterEmail = email;
    klaviyoSubscribe({ email: email, subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } });
    show("[data-step='2']");
  });
  var phoneForm = q("[data-phone-form]");
  if (phoneForm) phoneForm.addEventListener("submit", function (e) {
    e.preventDefault();
    var raw = (q("[data-phone-input]") || {}).value || "";
    if (!/^[+0][\d\s().-]{8,18}$/.test(raw.trim())) return;
    var phone = toE164FR(raw);
    var attrs = { subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } };
    if (boosterEmail) attrs.email = boosterEmail;
    if (phone) { attrs.phone_number = phone; attrs.subscriptions.sms = { marketing: { consent: "SUBSCRIBED" } }; }
    klaviyoSubscribe(attrs);
    show("[data-step='success']");
  });
  var back = q("[data-step-back]");
  if (back) back.addEventListener("click", function () { show("[data-step='1']"); });

  render();
})();
